
import { Component, OnInit, OnDestroy, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { Subscription } from "rxjs";

import { LoadingScreenService } from "../service/loading-screen.service";

@Component({
    selector: "app-loading-screen",
    templateUrl: "./loading-screen.component.html",
    styleUrls: ["./loading-screen.component.scss"],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: []
})
export class LoadingScreenComponent implements OnInit, OnDestroy {
  loading = true;
  loadingSubscription: Subscription;

  constructor(private loadingScreenService: LoadingScreenService) { }

  ngOnInit() {
    this.loadingSubscription = this.loadingScreenService.currentLoadingStatus.subscribe((value: boolean) => {
      this.loading = value;
    });
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
  }
}
